import axios from "axios";

class ProfileService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_PROFILE_URL;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }

    getGsmAccessStatus(contactId) {
        return this.restClient.get('/accessCheck/' + contactId + '/gsmAccessStatus');
    }

    callForgetUsername(captcha, email) {
        return this.restClient.get('/forgotUserName/forgot/' + email + '/' + captcha);
    }
    generateOTP(user) {
            return this.restClient.post('/otp/generate', {
            "otp": null,
            "msisdn": null,
            "username": user
        })
    }

    validateOTP(otp, user) {
        return this.restClient.post('/otp/validate', {
            "otp": otp,
            "msisdn": null,
            "username": user
        })
    }

    callForgetPassword(username, password) {
        return this.restClient.post('/forgotPassword/reset', {
            "confirmPassword": password,
            "newPassword": password,
            "username": username
        })
    }

    generateOtpForgotPassword(username, captcha) {
        return this.restClient.get('/forgotPassword/forgot/'+ captcha + '/' + username );
    }

    registerEbuUser(firstName , lastName , emailAddress , cellnumber , landline , businessName, jobTitle , vodacomAccNumber , captcha ,
                    documentTitle, idNumber, fileName, fileBuffer, accountType, selectedFile) {

        let params =  new URLSearchParams({
            "firstName": firstName,
            "lastName": lastName,
            "emailAddress": emailAddress,
            "cellnumber": cellnumber,
            "landline": landline,
            "businessName": businessName,
            "jobTitle": jobTitle,
            "vodacomAccNumber": vodacomAccNumber,
            "captcha": captcha,
            "idNumber": idNumber
        }).toString();

        if (accountType === "gsm") {
            let file = new File(
                [selectedFile],
                selectedFile.name, {
                    type: selectedFile.mimeType
                }
            );
            const formData = new FormData();
            formData.append('file', file);
            return this.restClient.post('/registration/gsm/register?' + params, formData, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            });
        } else {
            return this.restClient.post('/registration/fixed/register?' + params);
        }
    }

}

export default new ProfileService();
